import Title from '../../components/xocs/recommendation/title';
import parseAuthors from './authors';
import parsePageRange from './pageRange';

export default function createArticleProps(recommendationEntry, index) {
  const {
    authors,
    contentType,
    'document-type': documentType,
    'document-subtype': documentSubtype,
    doi,
    openAccessContent,
    pageRange,
    pdfPath,
    pii,
    'publication-date': publicationDate,
    'publication-date-number': publicationDateNumber,
    'journal-title': publicationName,
    title,
    'trace-token': traceToken,
  } = recommendationEntry;

  return {
    authors: parseAuthors({ authors }),
    contentType,
    documentType,
    documentSubtype,
    doi,
    openAccessContent,
    pageRange: parsePageRange(pageRange),
    pii,
    position: index + 1,
    publicationDate,
    publicationDateNumber,
    publicationName,
    pdfPath,
    title: <Title content={title.$$} />,
    traceToken,
  };
}
